import * as angular from "angular";
import {IController} from "angular";
import {SignupRequestsService} from "../../../authentication/services/signup-requests.service";
import {OrganizationsAlertsService} from "../../services/organizations-alerts.service";
import {OrganizationsDialogService} from "../../services/organizations-dialogs-service.factory";
import {OrganizationsRequestsService} from "../../services/organizations-requests.factory";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class OrganizationDetailsCtrl implements IController {


  organization: any;

  public loading: boolean = false;

  constructor(private $log, private organizationsAlertsService: OrganizationsAlertsService, private confirmDialogService: ConfirmDialogService,
              private organizationsDialogService: OrganizationsDialogService, private organizationsRequestsService: OrganizationsRequestsService, private signupRequestsService: SignupRequestsService) {
  }

  onEditInfo(event) {
    const originalCopy = angular.copy(this.organization);
    this.organizationsDialogService.editOrganizationInfo(event, this.organization)
      .then((editedOrganization) => {
        this.loading = true;
        return this.organizationsRequestsService.updateOrganization(this.organization.id, editedOrganization)
      })
      .then((updatedOrganization) => {
        this.organizationsAlertsService.updateSuccess(originalCopy);
        this.organization = updatedOrganization;
      })
      .catch((error) => {
        if (error) {
          this.organizationsAlertsService.updateError();
          this.$log.error('Failed to update organization', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  activateSubscription(event) {
    if (this.organization.subscriptionId) {
      this.confirmDialogService.confirm('Activate Subscription', 'Are you sure you want to activate this organization?', event)
        .then(() => {
          this.loading = true;
          return this.signupRequestsService.activateSubscription(this.organization.subscriptionId);
        })
        .then((updatedOrganization) => {
          this.organizationsAlertsService.updateSuccess(updatedOrganization);
          this.organization = updatedOrganization;
        })
        .catch((error) => {
          if (error) {
            this.organizationsAlertsService.updateError();
            this.$log.error('Failed to update organization', error);
          } else {
            this.$log.info('Dialog Closed');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }

  }

}


angular
  .module('bringoz.admin.organizations')
  .component('organizationDetails', {
    bindings: {
      organization: '<'
    },
    template: require('./organization-details.html').default,
    controller: OrganizationDetailsCtrl
  });
